import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _assertThisInitialized from "@babel/runtime/helpers/assertThisInitialized";
import _inherits from "@babel/runtime/helpers/inherits";
import * as React from "react";

var NetworkStatus = /*#__PURE__*/function (_React$Component) {
  _inherits(NetworkStatus, _React$Component);

  function NetworkStatus() {
    var _getPrototypeOf2;

    var _this;

    _classCallCheck(this, NetworkStatus);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _possibleConstructorReturn(_this, (_this = _possibleConstructorReturn(this, (_getPrototypeOf2 = _getPrototypeOf(NetworkStatus)).call.apply(_getPrototypeOf2, [this].concat(args))), _this.state = {
      online: "onLine" in navigator ? navigator.onLine : true
    }, _this.updateOnlineStatus = function () {
      if (_this.props.cb) {
        _this.props.cb(navigator.onLine);
      }

      _this.setState({
        online: navigator.onLine
      });
    }, _assertThisInitialized(_this)));
  }

  _createClass(NetworkStatus, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      addEventListener("offline", this.updateOnlineStatus);
      addEventListener("online", this.updateOnlineStatus);
      this.updateOnlineStatus();
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      removeEventListener("offline", this.updateOnlineStatus);
      removeEventListener("online", this.updateOnlineStatus);
    }
  }, {
    key: "render",
    value: function render() {
      return this.props.children(this.state.online);
    }
  }]);

  return NetworkStatus;
}(React.Component);

export default NetworkStatus;